import global from 'global';
var window = global.window,
    EventSource = global.EventSource;
export { storiesOf, setAddon, addDecorator, addParameters, configure, getStorybook, forceReRender, raw } from './preview';
export { getCustomElements, setCustomElements, setCustomElementsManifest, isValidComponent, isValidMetaData } from './customElements';
export * from './preview/types-6-0'; // TODO: disable HMR and do full page loads because of customElements.define

if (module && module.hot && module.hot.decline) {
  module.hot.decline(); // forcing full reloads for customElements as elements can only be defined once per page

  var hmr = new EventSource('__webpack_hmr');
  hmr.addEventListener('message', function fullPageReload(event) {
    try {
      // Only care for built events.  Heartbeats are not parsable so we ignore those
      var _JSON$parse = JSON.parse(event.data),
          action = _JSON$parse.action;

      if (action === 'built') {
        window.location.reload();
      }
    } catch (error) {// Most part we only get here from the data in the server-sent event not being parsable which is ok
    }
  });
}